<template>
    <div class="file">
        <vue-good-table
            id="file"
            :columns="file_columns"
            :rows="file_data"
            :sort-options="{
            enabled:false
            }"
        >
            <div slot="emptystate">
            Không có dữ liệu
            </div>
            <template
            slot="table-row"
            slot-scope="props"
            >
            <div v-if="props.column.field === 'file_name'">
                <CLink
                    :href="props.row.file_url"
                    target="_blank"
                >
                    {{props.row.file_name}}
                </CLink>
            </div>
            <div v-else-if="props.column.field === 'action'">
                <CButton
                    v-c-tooltip="'Xem file đính kèm'"
                    color="primary"
                    @click="downloadFile(props.row)"
                    variant="ghost"
                    :transparent="true"
                >
                    <i class='bx bx-download' ></i>
                </CButton>
            </div>
            </template>
        </vue-good-table>
    </div>  
</template>
 
<script>
import { VueGoodTable } from "vue-good-table";
export default {
    name: "ListFile",
    components:{
        VueGoodTable,
        },
    props: {

        file_data: []
    },
    data(){
        return{
            file_columns:[
                {
                    label: 'Tên tệp tin',
                    field: 'file_name',
                    thClass: 'emu-vgt-thead-th text-center',
                    tdClass: 'emu-vgt-tbody-td',
                },
                {
                    label: 'Tải tệp tin',
                    field: 'action',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
            ],
        }
    },
    methods: {
        downloadFile(file){
            //console.log(file)
            var a = document.createElement("a"); //Create <a>
            a.href =  file.file_url
            a.download = file.file_name; //File name Here
            a.target="_blank";
            a.click(); //Downloaded file
            a.remove();
        },
    }
}
</script>

<style lang="scss">
    .file{
      table.vgt-table td {
        vertical-align: inherit;
        color: black !important;
        font-size: 14.5px;
        //padding: 0.3rem !important;
        padding: 0em .75em .0em .75em;
      }
      .vgt-responsive {
        overflow-x: inherit;
      }
    }
    
</style>